import { render, staticRenderFns } from "./gatewayData.vue?vue&type=template&id=b4a99fa0&scoped=true&"
import script from "./gatewayData.vue?vue&type=script&lang=js&"
export * from "./gatewayData.vue?vue&type=script&lang=js&"
import style0 from "./gatewayData.vue?vue&type=style&index=0&id=b4a99fa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a99fa0",
  null
  
)

export default component.exports